import React from 'react';
import { I18n } from 'react-redux-i18n';
import proschet from 'proschet';
import Prompt from '@ui/Prompt';
import { PaymentApi } from '@api/payment';

const getPlanLength = plan =>
  plan.teacher ? plan.amount : Math.floor(plan.amount / 30);
const getPlanPrice = (plan, length) => {
  if (plan.prices.usd) {
    return Math.ceil(parseInt(plan.prices.usd) / length / 100);
  }
  if (plan.prices.eur) {
    return Math.ceil(parseInt(plan.prices.eur) / length / 100);
  }
  if (plan.prices.rub) {
    return Math.ceil(parseInt(plan.prices.rub) / length / 100);
  }
  return Math.ceil(parseInt(plan.price) / length / 100);
};

class Price extends React.Component {
  state = {
    paymentPlan: null,
  };

  fetchData = () => {
    const { plan, paymentPlan } = this.props;

    if (paymentPlan) {
      this.setState({ paymentPlan });
    } else {
      PaymentApi.getPaymentPlan({ plan }).then(res => {
        this.setState({ paymentPlan: res.plan });
      });
    }
  };

  componentWillMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.plan !== prevProps.plan ||
      this.props.paymentPlan !== prevProps.paymentPlan
    ) {
      this.fetchData();
    }
  }

  render() {
    const jobsList = [
      I18n.t('shop.oneLesson'),
      I18n.t('shop.twoLesson'),
      I18n.t('shop.tenLesson'),
    ];
    const getJobs = proschet(jobsList);

    const mounthList = [
      I18n.t('shop.oneMounth'),
      I18n.t('shop.twoMounth'),
      I18n.t('shop.tenMounth'),
    ];
    const getMounth = proschet(mounthList);

    const { showDetails, onClick } = this.props;

    const { paymentPlan } = this.state;

    if (!paymentPlan)
      return (
        <div className="plan-info">
          <i className="fa fa-spinner fa-pulse fa-3x fa-fw" />
        </div>
      );

    const currentLength = getPlanLength(paymentPlan);
    const currentPrice = getPlanPrice(paymentPlan, currentLength);
    const totalPrice = getPlanPrice(paymentPlan, 1);
    let currencySymbol = '₽';
    if (paymentPlan.prices.usd) currencySymbol = 'USD';
    if (paymentPlan.prices.eur) currencySymbol = 'EUR';

    let highestPrice = currentPrice;

    if (!showDetails) {
      return (
        <div className="plan-info" onClick={onClick}>
          <div className="plan-price">
            <div className="actual">
              <span className="value">{`${totalPrice.toLocaleString()}${currencySymbol}`}</span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="plan-info">
        <div className="plan-header">
          {paymentPlan.teacher ? (
            <div className="plan-times">
              {`${paymentPlan.amount} ${getJobs(paymentPlan.amount)}`}
            </div>
          ) : (
            <div className="plan-times">
              {`${currentLength} ${getMounth(currentLength)} ${I18n.t(
                'shop.tenLesson'
              )}`}
            </div>
          )}

          {paymentPlan.recurrent && (
            <div
              className="highlighted"
              style={{
                marginTop: '5px',
                display: 'block',
                width: 'fit-content',
              }}
            >
              <span>Автопродление</span>{' '}
              <Prompt>Можно отменить в любой момент</Prompt>
            </div>
          )}
        </div>

        <div className="plan-description">
          <b> {I18n.t('shop.total')} </b>
          <br />
          <div className="value">{`${totalPrice.toLocaleString()}${currencySymbol}`}</div>
          <hr className="hr" />
          <br />
          <b> {I18n.t('shop.youSave')} </b>
          <br />
          {Math.max(
            highestPrice * currentLength - totalPrice,
            0
          ).toLocaleString()}
          {currencySymbol}
        </div>
      </div>
    );
  }
}

export default Price;
